exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner[data-v-8874e6e4]{padding:0 15px}\n", ""]);

// exports
